<mat-chip-grid
    #chipGrid
    tabIndex="-1">
    <mat-chip-set>
        @for (item of tagsToShow(); track item?.id) {
            <mat-chip
                #chipTooltip="matTooltip"
                removable
                [matTooltip]="item.displayText"
                [disabled]="disabled()"
                (removed)="remove(item)"
                (click)="search(item)">
                {{ item.displayText }}
                <button
                    tabIndex="0"
                    matChipRemove
                    [attr.aria-label]="'remove ' + item"
                    [disabled]="disabled()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-chip>
        }
        @if (shouldShowTagsAsTooltipChip()) {
            <mat-chip
                #tooltip="matTooltip"
                [matTooltip]="tagsAsTooltip()"
                [disabled]="disabled()">
                {{ tagsAsTooltipChip() }}
            </mat-chip>
        }
        <mat-chip-listbox>
            <mat-chip-option
                selectable="false"
                class="st-tags-autocomplete-button"
                [class.st-tags-autocomplete-valid]="required() && internalValue()?.length === 0"
                [class.st-tags-autocomplete-required]="required()"
                [disabled]="disabled()"
                [matMenuTriggerFor]="listDropDownMenu"
                (menuClosed)="valueChanged()"
                (menuOpened)="onMenuOpened()"
                (keydown.space)="openMatMenu()"
                (keydown.enter)="openMatMenu()">
                <mat-icon matChipAvatar> add </mat-icon>
                <span class="st-tags-autocomplete-label">{{ label() }}</span>
            </mat-chip-option>
        </mat-chip-listbox>
    </mat-chip-set>
</mat-chip-grid>

<mat-menu
    #listDropDownMenu="matMenu"
    class="st-tags-autocomplete-menu">
    <form
        st-click-stop-propagation
        [dir]="dir">
        <mat-form-field
            subscriptSizing="dynamic"
            appearance="fill">
            <input
                #searchBox
                type="text"
                matInput
                [matChipInputFor]="chipGrid"
                [placeholder]="addTagLabel()"
                [formControl]="tagsFilter"
                (matChipInputTokenEnd)="add($event)"
                (keydown.esc)="onTabOrEscPress()"
                (keydown.tab)="onTabOrEscPress()"
                (keydown.arrowup)="onUpArrowPress()"
                (keydown.arrowdown)="onDownArrowPress()" />
        </mat-form-field>
        <mat-selection-list
            st-click-stop-propagation
            hideSingleSelectionIndicator
            multiple="false"
            [ngModel]="internalValue()"
            (selectionChange)="selected($event)">
            <mat-list-option
                *ngFor="let tag of suggestions | async"
                [value]="tag">
                <div matListItemTitle>{{ tag.displayText }}</div>
            </mat-list-option>
        </mat-selection-list>
    </form>
</mat-menu>
